import { useSyncExternalStore } from 'react';

/**
 * Subscribe to a media query.
 *
 * `useSyncExternalStore` rather than an effect + state: it reads the match during render, so
 * the first paint is already at the right density instead of flashing the phone layout and
 * then correcting. On a static app with no server render, that flash would be visible.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false, // no DOM: assume the phone case, matching mobile-first
  );
}
